const specialCharRegex = /[!@#$%^&()_+{};':"\\|,.<>/?[\]]/;

type TranslateFunction = (key: string) => string;

function getPasswordError(value: string, t: TranslateFunction): string | null {
    if (value.length < 10) return t("passwordValidation.minLength");
    if (!/[A-Z]/.test(value)) return t("passwordValidation.uppercase");
    if (!/[a-z]/.test(value)) return t("passwordValidation.lowercase");
    if (!/\d/.test(value)) return t("passwordValidation.digit");
    if (!specialCharRegex.test(value)) return t("passwordValidation.specialChar");
    return null;
}

export function validatePassword(value: string, t: TranslateFunction): string | null {
    return getPasswordError(value, t);
}
